'use client'

import { useEffect } from 'react'
import { AlertTriangle } from 'lucide-react'
import { ContentPageShell } from '@/components/layout/page-shell'
import { Button } from '@/components/ui/button'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <ContentPageShell>
      <div className="mx-auto max-w-md rounded-[var(--radius-xl)] border border-border bg-card p-8 text-center shadow-sm">
        <AlertTriangle className="mx-auto mb-6 h-14 w-14 text-amber-500" />
        <h1 className="mb-2 text-2xl font-semibold">Something went wrong</h1>
        <p className="mb-8 text-sm text-muted-foreground">An unexpected error occurred. Please try again.</p>
        <Button type="button" onClick={reset}>
          Try again
        </Button>
      </div>
    </ContentPageShell>
  )
}
